
import { Link } from 'react-router-dom';

const links = [
  {
    icon: 'ri-calculator-line',
    title: 'Get an Instant Quote',
    description:
      'Use our online tool for a quick estimate based on your acreage and service needs.',
    href: '/instant-quote',
    cta: 'Start Quote',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Calculate Your ROI',
    description: 'See how much you could save by switching to aerial application.',
    href: '/roi-calculator',
    cta: 'Run Calculator',
  },
  {
    icon: 'ri-question-answer-line',
    title: 'Browse FAQs',
    description:
      'Find answers to common questions about our services, pricing, and process.',
    href: '/faq',
    cta: 'View FAQs',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'View Case Studies',
    description:
      'See real results from farmers and landowners across the Mid-Atlantic.',
    href: '/case-studies',
    cta: 'Read Stories',
  },
];

export default function QuickLinks() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-stone-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block text-emerald-700 font-bold text-xs tracking-widest uppercase mb-3">
            Quick Access
          </span>
          <h2 className="text-3xl font-bold tracking-wide">
            Not Ready to Reach Out Yet?
          </h2>
          <p className="text-gray-600 mt-3 max-w-xl mx-auto">
            Explore these resources to learn more about what we offer and how we
            can help your operation.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {links.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 hover:shadow-md hover:border-emerald-100 transition-all group cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-emerald-50 rounded-lg mb-4 group-hover:bg-emerald-100 transition-colors">
                <i className={`${link.icon} text-xl text-emerald-700`}></i>
              </div>

              <h3 className="font-bold text-gray-900 mb-2">{link.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                {link.description}
              </p>

              <span className="inline-flex items-center text-sm font-semibold text-emerald-700 group-hover:text-emerald-800 transition-colors">
                {link.cta}
                <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
